import { Link } from "react-router-dom";
import { Home, Search } from "lucide-react";
import Logo from "@/components/Logo";
import ThemeToggle from "@/components/ThemeToggle";
import { Button } from "@/components/ui/button";

export default function NotFound() {
  return (
    <div className="relative flex min-h-screen flex-col items-center justify-center bg-background px-4 text-center grid-bg" data-testid="not-found">
      <div className="absolute right-4 top-4"><ThemeToggle /></div>
      <Logo />
      <p className="mt-10 font-num text-7xl font-black tracking-tight text-primary sm:text-8xl">404</p>
      <h1 className="mt-4 font-heading text-xl font-bold tracking-tight sm:text-2xl">Página não encontrada</h1>
      <p className="mt-2 max-w-md text-sm text-muted-foreground">
        A raposa farejou por toda parte e não achou esta página. Que tal voltar e ativar seu app? 🦊
      </p>
      <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
        <Button asChild className="gap-2" data-testid="notfound-home-btn">
          <Link to="/"><Home className="h-4 w-4" /> Voltar ao início</Link>
        </Button>
        <Button asChild variant="outline" className="gap-2" data-testid="notfound-activate-btn">
          <Link to="/"><Search className="h-4 w-4" /> Buscar aplicativos</Link>
        </Button>
      </div>
    </div>
  );
}
